import React from 'react';
import DitherGif from '../components/DitherGif/DitherGif';

// Temporary preview route for the DitherGif demo — not linked from
// anywhere in the site nav.
const DitherGifDemo: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px' }}>
      <div style={{ width: '100%', maxWidth: '960px', aspectRatio: '16 / 9' }}>
        <DitherGif src="/content/backdrops/fire-burning.mp4" />
      </div>
    </div>
  );
};

export default DitherGifDemo;
